import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNaNish } from 'helpers/balances';
import TabBar from './TabBar';

function QueryParamTabs(props) {
  const activeTabRef = useRef(null);
  const [activeTabIndex, setActiveTabIndex] = useState(null);

  useEffect(() => {
    const newIndex = activeTabRef.current?.dataset?.index;
    if (newIndex) {
      const newIndexInt = parseInt(newIndex, 10);
      if (!isNaNish(newIndexInt)) setActiveTabIndex(parseInt(newIndex, 10));
    }
  }, [props.location.search]);

  const renderTabBar = () => {
    if (typeof props.renderCustomTabBar === 'function') {
      return props.renderCustomTabBar({
        tabs: props.tabs,
        activeTabIndex,
        activeTabRef,
        location: props.location,
        border: props.border
      });
    }
    return (
      <TabBar
        tabs={props.tabs}
        activeTabIndex={activeTabIndex}
        activeTabRef={activeTabRef}
        location={props.location}
        border={props.border}
      />
    );
  };

  const renderTabContent = () => {
    const Component = props.tabs[activeTabIndex].component;
    return <Component {...props.tabProps} />;
  };

  const content = activeTabIndex !== null ? <>{renderTabContent(props.tabs[activeTabIndex])}</> : null;

  return (
    <>
      {renderTabBar()}
      {content}
    </>
  );
}

QueryParamTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      queryParam: PropTypes.string.isRequired,
      component: PropTypes.func.isRequired
    })
  ),
  tabProps: PropTypes.any, // eslint-disable-line
  border: PropTypes.bool, // eslint-disable-line
  location: PropTypes.object.isRequired,
  renderCustomTabBar: PropTypes.func // eslint-disable-line
};

QueryParamTabs.defaultProps = {
  tabs: [],
  border: true,
  tabProps: {},
  renderCustomTabBar: undefined // eslint-disable-line
};

export default QueryParamTabs;
